export const MAX_CHARS_PER_LINE = 8; // including the trailing hyphen or ellipsis, if any
export const MAX_LINES = 3; // if text is truncated, ellipsis will be at the end of the last line

const removeExtraWhitespaces = (label) => {
  return label.trim().replace(/\s+/g, ' ');
};

export const splitLabelIntoLines = (label) => {
  label = removeExtraWhitespaces(label);
  const lines = [];
  let lineStart = 0;

  for (let currentLineNumber = 1; currentLineNumber <= MAX_LINES && lineStart < label.length; currentLineNumber++) {
    // check if the rest of the label fits on one line
    if (label.length - lineStart <= MAX_CHARS_PER_LINE) {
      lines.push(label.substring(lineStart));
      break;
    }

    // if the rest of the label does not fit on one line but it is the last line, we need to add ellipsis
    if (currentLineNumber === MAX_LINES) {
      lines.push(`${label.substring(lineStart, lineStart + MAX_CHARS_PER_LINE - 3)}...`);
      break;
    }

    const lineEndIdx = lineStart + MAX_CHARS_PER_LINE - 1;

    if (
      label[lineEndIdx - 1] === ' ' &&
      label[lineEndIdx] !== ' ' &&
      label[lineEndIdx + 1] !== ' '
    ) {
      lines.push(label.substring(lineStart, lineEndIdx));
      lineStart += MAX_CHARS_PER_LINE - 1;
      continue;
    }

    // a hyphen is not needed if any of the following conditions are met:
    // the current line ends with a whitespace
    // the current line ends with the first letter of the word immediately preceded by a whitespace
    // the next line starts with a whitespace
    const needHyphen = label[lineEndIdx] !== ' ' && label[lineEndIdx + 1] !== ' ';
    if (needHyphen) {
      lines.push(`${label.substring(lineStart, lineEndIdx)}-`);
      lineStart += MAX_CHARS_PER_LINE - 1;
    } else {
      lines.push(label.substring(lineStart, lineEndIdx + 1));
      lineStart += MAX_CHARS_PER_LINE;
    }
  }

  return lines;
};
